<div class="bg-[#f5f6fa] min-h-screen flex flex-col items-center justify-center py-6 px-2">
  <div class="w-full max-w-2xl bg-white rounded-lg shadow p-4 md:p-8">
    <div [innerHTML]="privacyContent"></div>
  </div>
</div>

<!-- <div class="row">
<div class="col s12">
  <div class="container">
      <div [innerHTML]="dom"></div>
  </div>
</div>
</div> -->
